export default function () {
    return (
        <svg width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_1975_20560)">
                <path
                    d="M31.125 7.25H4.875C4.04657 7.25 3.375 7.92157 3.375 8.75V24.875C3.375 25.7034 4.04657 26.375 4.875 26.375H31.125C31.9534 26.375 32.625 25.7034 32.625 24.875V8.75C32.625 7.92157 31.9534 7.25 31.125 7.25Z"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M28.75 10.625H7.25C6.97386 10.625 6.75 10.8489 6.75 11.125V22.5C6.75 22.7761 6.97386 23 7.25 23H28.75C29.0261 23 29.25 22.7761 29.25 22.5V11.125C29.25 10.8489 29.0261 10.625 28.75 10.625Z"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7.875 29.5239L9.5625 26.6011" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M28.6875 29.5239L27 26.6011" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_1975_20560">
                    <rect width="36" height="36" fill="white" transform="translate(0 0.5)" />
                </clipPath>
            </defs>
        </svg>
    );
}
